import React from "react";
import {EmployeeStatus, EmployeeTimeEntry} from "@/data/entities/employee";
import TimeEntryItem from "@widgets/timeRegistration/authenticated/timeEntries/TimeEntryItem";

type Props = {
    employee: EmployeeStatus,
};

const TimeEntriesList = ({employee}: Props) => {
    return (
        <ol className={"w-full flex flex-col gap-2 text-sm text-gray-600 dark:text-gray-400 max-h-[200px] overflow-y-auto"}>
            {employee.timeEntries.map((entry: EmployeeTimeEntry) =>
                <React.Fragment key={entry.id}>
                    {
                        entry.clockOut !== null &&
                        <TimeEntryItem
                            clockedIn={false}
                            date={entry.clockOut}
                        />
                    }

                    <TimeEntryItem
                        clockedIn={true}
                        date={entry.clockIn}
                    />
                </React.Fragment>
            )}
        </ol>
    );
};

export default TimeEntriesList;